module.exports = __webpack_public_path__ + "img/header4.038459df.png";